import { ClockIcon } from "lucide-react"
import { formatDistanceToNow, format } from "date-fns"

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@f2e/ui/components/base"
import { cn } from "@f2e/ui/lib/utils"

interface ClockProps {
  className?: string
  dateAt: string
}

const Clock = ({ className, dateAt }: ClockProps) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={cn("flex items-center", className)}>
            <ClockIcon className="w-4 h-4 inline mr-1" />
            {formatDistanceToNow(new Date(dateAt)).replace(
              /^(\d+)\s+(\w).*$/,
              "$1$2"
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          {format(new Date(dateAt), "yyyy-MM-dd HH:mm:ss")}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}

export default Clock
